
export function required(inputElement: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement, isRequired: boolean) {
    inputElement.required = isRequired;
}